<script setup lang="ts">
import Swal from 'sweetalert2';



const curtailType = ref();
const curtailValue = ref();


function selectMode(event: Event, type: string){

  curtailType.value = type;

  let doc = document.getElementsByClassName('btn-curtail');

  for(let i = 0; i < doc.length; i++){
    if(doc[i].classList.contains('active')){
      doc[i].classList.remove('active');
    }
  }

  event.target.classList.add('active');
}

function submitCurtail(){
  Swal.fire({
    icon: 'warning',
    text: '준비중입니다.',
    confirmButtonColor: "#1949e9",
    confirmButtonText: "확인",
  })
}

</script>

<template>
  <div class="curtailment-card common-card col-12 h-100">
    <div class="title">
      출력제어 모드
    </div>
    <div class="contents">
      <div class="btn-list">
        <button class="btn btn-curtail active" @click="selectMode($event, 'auto')">자동 모드</button>
        <button class="btn btn-curtail" @click="selectMode($event, 'manual')">수동 모드</button>
      </div>
      <div class="curtailment-value">
        <label>출력 제어율</label>
        <div class="input-area" :class="curtailType === 'auto' ? 'disabled' : ''">
          <input type="number" v-model="curtailValue" :disabled="curtailType === 'auto'" />
          <span class="input-area-unit">%</span>
        </div>
      </div>
      <div class="btn-submit">
        <button class="btn btn-primary" @click="submitCurtail">적용</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/design-toc/define.scss";

.curtailment-card{
  .title{
    color: #262626;
    font-family: "Wanted Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 66.667% */  
    padding: 15px 0px;  
  }
  .contents{
   .btn-list{
    background: #C9C9C9;
    padding: 4px;
    align-items: flex-start;
    display: flex;
    gap: 6px;
    flex-shrink: 0;
    justify-content: space-between;
    .btn-curtail{
      width: 49%;
      padding: 10px 8px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 4px;
      background: #E2E2E2;  
      color: var(--Neutral-Colors-800, #19213D);
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 19.2px */
      box-shadow: 0 1px 4px 0 rgba(78, 159, 255, 0.20);
      &.active{
        background: #2388FF;
        color: var(--Neutral-Colors-200, #F8FAFF);
      }
    }
   } 
   .curtailment-value{
    display: flex;
    padding: 10px 0px;
    width: 100%;
    label{
      display: flex;
      padding: 10px 8px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 6px 0 0 6px;
      background: #E2E2E2;
      color: var(--Neutral-Colors-800, #19213D);
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
    .input-area{
      border-radius: 0 6px 6px 0;
      border: 1px solid var(--Neutral-Colors-400, #E1E4ED);
      display: flex;
      align-items: center;
      flex-flow: row;
      width: 100%;
      &.disabled{
        background-color: rgba(118, 118, 118, 0.3);
      }
      input{
        text-align: right;
        padding: 10px 8px;
        border: none;
        color: var(--Neutral-Colors-800, #19213D);
        text-align: right;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 16.8px */
        flex-basis: auto;
        width: 100%;
        &:focus-visible{
          border: none;
          outline: none;
        }
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        &:disabled{
          background-color: transparent;
        }
      }

      .input-area-unit{
        flex-basis: 0;
        color: #C5C8CB;
        text-align: right;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 16.8px */
        padding: 0px 5px;
      }
    }
   }
   .btn-submit{
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}

</style>